@let score = ratingScore();

@if (score) {
  @if (showIcon()) {
    <rt-icon
      [name]="score.icon"
      [size]="iconSize()"
      [colorToken]="colorize() ? score.color : undefined"
    />
  }

  @if (showRatingScoreLabel()) {
    <span [class]="labelClass()">{{ score.ratingLabel }}</span>
  }
}
